import Enums from "@/enums";
import Helpers from "@/Helpers";
import { parseSanitizedHtml } from "@/utils/sanitizeHtml";

type ContentFormat = (typeof Enums.CONTENT_FORMAT)[keyof typeof Enums.CONTENT_FORMAT];

type RenderFormattedContentOptions = {
   className?: string;
   format?: ContentFormat | null;
};

export function renderFormattedContent(
   content: string | null | undefined,
   options: RenderFormattedContentOptions = {},
) {
   const text = typeof content === "string" ? content : "";
   if (!text.trim()) return null;

   const className = options.className ?? "plainContent";
   const format = options.format;
   const treatAsHtml = format === Enums.CONTENT_FORMAT.HTML
      || (format !== Enums.CONTENT_FORMAT.Text && Helpers.shouldRenderContentAsHtml(text));

   if (treatAsHtml) {
      try {
         return parseSanitizedHtml(text);
      } catch (error) {
         console.error("Error parsing HTML content:", error);
         return <span className={className}>{text}</span>;
      }
   }

   return <span className={className}>{text}</span>;
}
